import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

type ProfileImageProps = {
  imgUrl?: string;
  nameLetters?: string;
};

const ProfileImage = ({
  imgUrl = "",
  nameLetters = "Z",
}: ProfileImageProps) => (
  <Avatar className="flex items-center justify-start gap-2 font-medium">
    <AvatarImage src={imgUrl} />
    <Avatar className="bg-primary text-lg text-primary-foreground">
      <AvatarFallback className="bg-primary text-lg uppercase text-primary-foreground">
        {nameLetters}
      </AvatarFallback>
    </Avatar>
  </Avatar>
);

export default ProfileImage;
